import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { Item } from '../models/item';
import { Option } from '../models/option';
import { Order } from '../models/order';
import { OrderItem } from '../models/order-item';
import { OrderOption } from '../models/order-option';
import { User } from '../models/user';
import { OptionGroupService } from '../services/option-group.service';
import { OrderService } from '../services/order.service';
import { ShopService } from '../services/shop.service';
import { UserService } from '../services/user.service';
import { ShopHelper } from './shop-helper';
import { MyMoment } from './time-helper';
import { UIDGenerator } from './uid-generator';

@Injectable({
  providedIn: 'root',
})
export class OrderHelper {

  constructor(
    private shopService: ShopService,
    private userService: UserService
  ) {}

  async buildNewOrder() {
    const user = await this.userService.getCurrentUser().pipe(take(1)).toPromise();
    const shop = await this.shopService.getCurrentShop().pipe(take(1)).toPromise();
    if (!user || !shop) { return; }

    const order = new Order();
    order.uid = UIDGenerator.generate();
    order.status = 'being-created';
    order.log = [];
    order.shop = JSON.parse(JSON.stringify(shop));
    order.user = JSON.parse(JSON.stringify(user));
    order.orderItems = [];
    order.address = user.addresses[user.addresses.length - 1];
    order.submittedAt = '';
    order.completedAt = '';
    // order.easypayPayment = {} as EasypayPayment;

    return order;
  }

  itemToOrderItem(item: Item, quantity: number) {
    const orderItem = new OrderItem();
    for (const k in item) { orderItem[k] = item[k]; }
    orderItem.quantity = quantity;

    return orderItem;
  }

  optionToOrderOption(option: Option, quantity: number) {
    const orderOption = new OrderOption();
    for (const k in option) { orderOption[k] = option[k]; }
    orderOption.quantity = quantity;

    return orderOption;
  }

  removeOrderItem(order: Order, orderItem: OrderItem) {
    order.orderItems.findIndex((orderItem) => orderItem.uid === orderItem.uid);
  }

  getOrderSubTotal(order: Order) {
    let subTotal = 0;
    order.orderItems.forEach(orderItem => subTotal += this.getOrderItemTotal(orderItem));
    return subTotal;
  }

  getOrderTotal(order: Order) {
    return this.getOrderSubTotal(order) + order.shop.deliveryFee;
  }

  getOrderItemTotal(orderItem: OrderItem) {
    let total = 0;

    total += orderItem.price;
    orderItem.optionsSelected.forEach(optionSelected => {
      total += optionSelected.price * optionSelected.quantity;
    });
    total *= orderItem.quantity;

    return total;
  }

  updateOrderExpectedArrivalIfNeeded(order) {
    if (order.arrivalExpectedAt) {
      const expectedArrivalMoment = MyMoment.parse(order.arrivalExpectedAt);
      const earliestArrivalMoment = MyMoment.todayAt(ShopHelper.earliestArrivalTime(order.shop));
      if (expectedArrivalMoment.toMinutes() < earliestArrivalMoment.toMinutes()) {
        order.arrivalExpectedAt = earliestArrivalMoment.toString();
        return true;
        // this.orderService.setCurrentOrder(order);
        // this.timeSelected = earliestArrivalMoment.time;
      } else {
        // this.timeSelected = expectedArrivalMoment.time;
      }
    } else {
      const arrivalTimes = ShopHelper.getArrivalTimes(order.shop);
      const moment = MyMoment.todayAt(arrivalTimes[0]);
      order.arrivalExpectedAt = moment.toString();
      return true;
      // this.orderService.setCurrentOrder(order);
    }

    return false;
  }

  areEquals(option: Option, orderOption: OrderOption) {
    if (option.name !== orderOption.name) { return false; }
    if (option.price !== orderOption.price) { return false; }
    if (option.description !== orderOption.description) { return false; }

    return true;
  }

}
